<template>
    <validation-errors />

    <form
        @submit.prevent="submit"
        class="
            w-full
            sm:max-w-md
            mt-6
            px-6
            py-4
            bg-secondary
            shadow-md
            overflow-hidden
            sm:rounded-lg
        "
    >
        <div>
            <input-component
                id="email"
                type="email"
                class="mt-1"
                v-model="form.email"
                placeholder="Email"
                required
                autofocus
                autocomplete="username"
            />
        </div>

        <div class="mt-4">
            <input-component
                id="password"
                type="password"
                class="mt-1"
                v-model="form.password"
                placeholder="Password"
                required
                autocomplete="new-password"
            />
        </div>

        <div class="mt-4">
            <input-component
                id="password_confirmation"
                type="password"
                class="mt-1"
                v-model="form.password_confirmation"
                placeholder="Confirm Password"
                required
                autocomplete="new-password"
            />
        </div>

        <div class="flex items-center justify-end mt-4">
            <button-component
                class="ml-4"
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
            >
                Reset Password
            </button-component>
        </div>
    </form>
</template>

<script>
import ButtonComponent from "@/Components/Button";
import GuestLayout from "@/Layouts/Guest";
import InputComponent from "@/Components/Input";
import ValidationErrors from "@/Components/ValidationErrors";

export default {
    layout: GuestLayout,

    components: {
        ButtonComponent,
        InputComponent,
        ValidationErrors,
    },

    props: {
        email: String,
        token: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                token: this.token,
                email: this.email,
                password: "",
                password_confirmation: "",
            }),
        };
    },

    methods: {
        submit() {
            this.form.post(this.route("password.update"), {
                onFinish: () =>
                    this.form.reset("password", "password_confirmation"),
            });
        },
    },
};
</script>
